var _jsxFileName = "/var/home/clovis/Documents/Mangane/app/soapbox/components/ui/emoji-react/emoji-react.tsx";
const _excluded = ["emoji", "alt"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from 'react';
import Emoji from '../emoji/emoji';
/** A single emoji reaction. Support custom emojis. */
const EmojiReact = props => {
  const {
      emoji,
      alt
    } = props,
    rest = _objectWithoutProperties(props, _excluded);
  if (emoji.get('url')) {
    return /*#__PURE__*/React.createElement("img", _extends({
      draggable: "false",
      alt: alt || emoji.get('name'),
      src: emoji.get('url')
    }, rest, {
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 18,
        columnNumber: 7
      }
    }));
  }
  return /*#__PURE__*/React.createElement(Emoji, _extends({
    emoji: emoji.get('name'),
    alt: alt
  }, rest, {
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 27,
      columnNumber: 10
    }
  }));
};
export default EmojiReact;